import { Injectable } from '@angular/core';
import { MaterialDemandsDaoService } from '../material-demand-dao.service';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import {
  DbPersistenceService,
  Query,
} from 'src/app/_services/persistence/db-persistence/db-persistence.service';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { MaterialDemandDbTableDefinition } from './material-demand-db-table-definition';
import { MaterialDemand } from 'src/app/_model/material-demand';

@Injectable()
export class MaterialDemandsDbDaoService implements MaterialDemandsDaoService {
  constructor(
    private logger: LoggingService,
    private dbPersistenceService: DbPersistenceService,
    private appParameter: AppParameterService,
    private materialDemandTableDefinition: MaterialDemandDbTableDefinition,
  ) {}

  public async saveMaterialDemands(
    materialDemands: MaterialDemand[],
  ): Promise<void> {
    try {
      let db = await this.dbPersistenceService.getImsDb();
      var queries: Query[] = [];
      for (const data of materialDemands) {
        let query: Query = {
          statement:
            'INSERT OR REPLACE INTO ' +
            this.materialDemandTableDefinition.tableName +
            '(id, label, databag, servicejobid, servicejoblabel, demandstatus, demandnumber, demanddate, assignedemployeeid, assignedemployeelabel, requestedbyemployeeid, requestedbyemployeelabel, extid)' + // 2
            ' VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?)',
          parameters: [
            Number(data.getImsId()),
            data.label,
            data.databag ? JSON.stringify(data.databag) : undefined,
            data.servicejob ? Number(data.servicejob.getImsId()) : undefined,
            data.servicejob ? data.servicejob.label : undefined,
            data.demandStatus,
            data.demandNumber,
            data.demandDate,
            data.assignedEmployee
              ? Number(data.assignedEmployee.getImsId())
              : undefined,
            data.assignedEmployee ? data.assignedEmployee.label : undefined,
            data.requestedByEmployee
              ? Number(data.requestedByEmployee.getImsId())
              : undefined,
            data.requestedByEmployee
              ? data.requestedByEmployee.label
              : undefined,
            data.extId,
          ],
        };
        queries.push(query);
      }
      await this.dbPersistenceService.executeBatch(db, queries);
    } catch (error) {
      this.logger.log(
        'Error saving',
        this.materialDemandTableDefinition.tableName,
        'to db',
        error,
        '-',
        error?.message,
      );
    }
  }

  public async getMaterialDemands(): Promise<MaterialDemand[]> {
    try {
      let db = await this.dbPersistenceService.getImsDb();
      let objects: MaterialDemand[] = [];

      let data = await this.dbPersistenceService.executeQuery(db, {
        statement:
          'SELECT * FROM ' + this.materialDemandTableDefinition.tableName + ';',
        parameters: null,
      });
      for (let i = 0; i < data.values.length; i++) {
        let row = data.values[i];
        objects.push(
          MaterialDemand.fromDto(
            {
              id: row['id'],
              label: row['label'],
              servicejob: {
                id: row['servicejobid'],
                label: row['servicejoblabel'],
              },
              demandstatus: row['demandstatus'],
              demandnumber: row['demandnumber'],
              demanddate: row['demanddate'],
              assignedemployee: {
                id: row['assignedemployeeid'],
                label: row['assignedemployeelabel'],
              },
              requestedbyemployee: {
                id: row['requestedbyemployeeid'],
                label: row['requestedbyemployeelabel'],
              },
              secondaryid: undefined,
              extid: row['extid'],
            },
            row['databag'] ? JSON.parse(row['databag']) : undefined,
            this.appParameter.getFormatLabelForObject('ims/MaterialDemand'),
          ),
        );
      }
      return objects;
    } catch (error) {
      this.logger.log(
        'Error reading',
        this.materialDemandTableDefinition.tableName,
        'from db',
        error,
      );
    }
    return [];
  }

  public async reset() {}

  public async clear() {
    let db = await this.dbPersistenceService.getImsDb();
    this.logger.log(
      this.constructor.name,
      'truncate table',
      this.materialDemandTableDefinition.tableName,
    );
    await this.dbPersistenceService.truncateTable(
      db,
      this.materialDemandTableDefinition.tableName,
    );
  }
}
